import { jsxs, jsx } from "react/jsx-runtime";
import { event } from "@zillow/universal-analytics";
import { yieldCallback } from "@zillow/yield-callback";
import { usePageProps, withPreload, getCmsInfoForPage, ColorCard, CardImage } from "@zillow/zrs-cms";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
import { withTrigger } from "../../util/helpers.esm.js";
import { usePopulateParamPlaceHolders, populateParamPlaceholders } from "../../util/populateParamPlaceholders.esm.js";
const CardImagePreload = withPreload(CardImage);
const CardWithTrigger = withTrigger(ColorCard);
const BlockCard = ({
  attrs,
  index,
  innerBlocks
}) => {
  const pageProps = usePageProps();
  const {
    textAlign = "inherit",
    cardImage = {},
    loading = "lazy",
    // Legacy v8 props — kept for backward compat with saved WP blocks
    cardElevation = 1,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cardDirection: _cardDirection,
    appearance = "default",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cardType: _cardType,
    // v10 props — take precedence when present (already-migrated blocks)
    elevated: elevatedProp,
    outlined: outlinedProp,
    tone: toneProp,
    link,
    backgroundColor,
    fontColor = "textDark",
    padding = {
      paddingTop: {
        default: "sm"
      },
      paddingBottom: {
        default: "sm"
      },
      paddingRight: {
        default: "sm"
      },
      paddingLeft: {
        default: "sm"
      }
    },
    id,
    ...rest
  } = attrs;
  const linkUrl = typeof link === "string" ? link : link == null ? void 0 : link.url;
  const opensInNewTab = typeof link === "object" ? (link == null ? void 0 : link.opensInNewTab) ?? false : false;
  const isModalLink = !!linkUrl && linkUrl.startsWith("#");
  const outlined = outlinedProp ?? appearance !== "borderless";
  const elevated = elevatedProp ?? cardElevation !== 0;
  const tone = toneProp;
  const blockAnchorUrl = usePopulateParamPlaceHolders(!isModalLink && !opensInNewTab ? linkUrl : void 0) ?? void 0;
  return /* @__PURE__ */ jsxs(CardWithTrigger, { id, style: {
    textAlign
  }, css: {
    height: "100%",
    maxWidth: "100%"
  }, elevated, outlined, tone, backgroundColor, fontColor, interactive: !!linkUrl, blockAnchorUrl, triggerLink: isModalLink ? linkUrl : void 0, onMouseEnter: (e) => {
    event({
      // https://dataportal.zillowgroup.net/event-registry/2049
      envelope: {
        event_type_id: "2049",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_card",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_hover"
      },
      cms_info: {
        block_id: id || "",
        block_type_cd: "card",
        block_displayed_txt: e.target.textContent,
        block_target_url: linkUrl || "",
        block_target_window_txt: opensInNewTab ? "_blank" : "",
        ...getCmsInfoForPage(pageProps)
      }
    });
  }, onClick: (e) => {
    if (!linkUrl) return;
    const url = populateParamPlaceholders(linkUrl);
    if (!isModalLink && opensInNewTab) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
    if (!isModalLink && !opensInNewTab && e.detail === 0) {
      window.location.href = url;
    }
    const clickPayload = {
      // https://dataportal.zillowgroup.net/event-registry/2048
      envelope: {
        event_type_id: "2048",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_card",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_click"
      },
      cms_info: {
        block_id: id || "",
        block_type_cd: "card",
        block_displayed_txt: e.target.textContent,
        block_target_url: url,
        block_target_window_txt: opensInNewTab ? "_blank" : "",
        ...getCmsInfoForPage(pageProps)
      }
    };
    if (!isModalLink && !opensInNewTab) {
      event(clickPayload);
    } else {
      yieldCallback(() => event(clickPayload))();
    }
  }, ...padding, ...rest, children: [
    cardImage.src && /* @__PURE__ */ jsx(CardImagePreload, { ...cardImage, loading, decoding: cardImage.decoding || "async" }),
    generateBlockList({
      blocks: innerBlocks
    })
  ] }, index);
};
export {
  BlockCard as default
};
